import { render, staticRenderFns } from "./ExchangeProductSlotRight.vue?vue&type=template&id=0dd394ed&"
import script from "./ExchangeProductSlotRight.vue?vue&type=script&lang=ts&"
export * from "./ExchangeProductSlotRight.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports